import CalculateMarginActions from "@redux/feature/Tools/MarginCalculator/actions/CalculateMargin";
export default (function () {
    return {
        marginCalculator: {
            calculateMargin: new CalculateMarginActions(),
        },
    };
});
